;(function($, undefined){
    var rnn = window.rnn;

    function refreshMap($map){
        var data = $map.data(),
            map,
            marker;

        if(!data){
            return;
        }

        map = data.map;
        marker = data.marker;

        if(map){
            map.refresh();
            if(marker){
                var markerPosition = marker.getPosition();
                map.setCenter(markerPosition.lat(), markerPosition.lng());
            }
        }
    }

    function createMenu(){
        var menu = $($.el.nav({'class':'menu'}, 'Pick a location')),
            cancelButton = $($.el.button({'class':'btn closeModal', 'type':'button'}, 'Done')),
            useMyLocationButton = $($.el.button({'class':'btn useMyLocation', 'type':'button'}, $.el.i({'class':'icon14x14-crosshair'})));

        menu.append(cancelButton, useMyLocationButton);

        return menu;
    }

    function activatePicker(widget){
        var settings = widget.data('module'),
            menu = settings.menu;

        if(!menu){
            menu = settings.menu = createMenu();
            widget.append(menu);
        }

        rnn.modules.modal.show(widget);
        refreshMap(widget.find('.map'));
    }

    function deactivatePicker(widget){
        widget.removeClass('active').find('.overlay').show();
        refreshMap(widget.find('.map'));
    }

    function overlayClickHandler(event){
        var widget = $(event.target).closest('.locationPickerWidget'),
            overlay = $('.overlay', widget);

        overlay.hide();

        activatePicker(widget);
    }

    function modalCloseHandler(event){
        event.stopPropagation();
        deactivatePicker($(this));
    }

    function createLocationPickerWidget(){
        var widget = $(this),
            overlay = $($.el.button({'class':'overlay', 'type':'button'}, 'Tap to pick a location')),
            map = $($.el.div({'class':'map'})),
            settings = widget.data();

        map.data('map-marker', settings.mapMarker);
        widget.addClass('mobileModal');
        widget.append(overlay);
        widget.append(map);
        rnn.modules.maps.createLocationPickerMap(map);

        if(!widget.data('module')){
            widget.data('module', {});
        }
    }

    function updateLocation(widget){
        rnn.modules.location.getLocation(function(location){
            var locationChangedEvent = $.Event('locationchanged');

            locationChangedEvent.location = location;
            locationChangedEvent.target = widget[0];

            widget.find('.map').trigger(locationChangedEvent);
        });
    }

    function useMyLocation(widget, use){
        var interval = widget.data('interval');
        clearInterval(interval);
        if(use){
            updateLocation(widget);
            interval = setInterval(function(){
                updateLocation(widget);
            },5000);
            widget.data('interval', interval);
            widget.find('.useMyLocation').addClass('active');
        }else{
            widget.find('.useMyLocation').removeClass('active');
        }
    }

    function useMyLocationClickHandler(){
        var button = $(this).closest('.btn'),
            widget = $(this).closest('.locationPickerWidget');

            useMyLocation(widget, !button.hasClass('active'));
    }

    function locationChangedHandler(event){
        if(!$(event.target).is('.locationPickerWidget')){ //We dont want to listen to our own events!
            useMyLocation($(event.target).closest('.locationPickerWidget'), false);
        }
    }

    function resizeHandler(){
        $('.locationPickerWidget').each(function(){
            refreshMap($(this).find('.map'));
        });
    }

    function initLocationPickerWidget(){
        $('.locationPickerWidget').each(createLocationPickerWidget);

        $(document).on('click touch', '.locationPickerWidget .overlay', overlayClickHandler)
            .on('closeModal','.mobileModal', modalCloseHandler)
            .on('click', '.locationPickerWidget .useMyLocation', useMyLocationClickHandler)
            .on('locationchanged addresschanged', '.locationPickerWidget', locationChangedHandler);

        $(window).on('resize', resizeHandler);
    }

    rnn.modules.register('locationPickerWidget', {
        init: initLocationPickerWidget,
        create: function(target){
            $(target).each(createLocationPickerWidget);
        }
    });

})(jQuery);
